import {
  put, call, all, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import { setTechReports, setTechReportFailure } from '../state/action/techLogAction';
import { GET_TECH_REPORTS } from '../state/types';
import fetch from '../services/fetch';
import { BASE_URL } from '../config';

function* getReports({ projectNo }) {
  let status = 0;
  try {
    const projNo = encodeURIComponent(projectNo.projectNo).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
    const res = yield fetch(`${BASE_URL}/reports?projectNumber=${projNo}&type=TechLog`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (res.status === 403) {
      status = res.status;
      throw new Error('Unauthorized');
    }
    const response = yield res.json();
    yield put(setTechReports({ response }));
  } catch (error) {
    yield put(setTechReportFailure());
    if (status !== 403) {
      notification.error({
        message: 'There was a problem fetching the report details.',
        description: `${error}`,
      });
    }
  }
}

function* techLogWatcher() {
  yield takeLatest(GET_TECH_REPORTS, getReports);
}

function* techLogSagas() {
  yield all([
    call(techLogWatcher),
  ]);
}

export default techLogSagas;
